export default __webpack_public_path__ + "static/media/logo.bf2d06a0.png";